import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ErrorPage, ErrorPageService} from '../../service/error-page.service';
import {LoginRequestService} from '../../service/login-request.service';
import {Utilities} from '../../utilities/utilities.model';
import {Router} from '@angular/router';
import {LoaderService} from '../../service/loader.service';
import bodymovin from 'bodymovin/build/player/bodymovin_light.min.js';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-error-page',
	templateUrl: './error-page.component.html',
	styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit, OnChanges {
	public PAGE_NOT_FOUND = ErrorPage.PAGE_NOT_FOUND;
	public OPS = ErrorPage.OPS;
	public LOGOUT = ErrorPage.LOGOUT;
	public NOT_COMMODITIES = ErrorPage.NOT_COMMODITIES;
	public GO_TO = ErrorPage.GO_TO;
	public URL_ERROR = ErrorPage.URL_ERROR;

    animation: any;

	@Input() errorPage: ErrorPage;
	translateContext: TranslateContext = TranslateContext.SHARED;

	constructor(
		private loaderService: LoaderService,
		private router: Router,
		private errorPageService: ErrorPageService) {
	}

	ngOnInit() {
    }
    
    ngAfterViewInit() {
        //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
        //Add 'implements AfterViewInit' to the class.
        this.loadErrorAnimation();
    }
	ngOnChanges(changes: SimpleChanges): void {

        if (!Utilities.isVoid(changes.errorPage) && !Utilities.isVoid(changes.errorPage.currentValue)) {
            this.loaderService.display(false);
		}
        
    }
    
	onClick(event: any) {
		if (this.errorPage.buttonTxt === this.LOGOUT) {
			LoginRequestService.logout();
		} else {
			if (!Utilities.isVoid(this.errorPage.route)) {
				this.router.navigate(this.errorPage.route);
				this.errorPageService.pushErrorPage(null);
			}
		}
	}

    private loadErrorAnimation() {

		const elementId = 'errorAnimationId';

		const animationParams = {
			container: document.getElementById(elementId),
			renderer: 'svg',
			loop: false,
			autoplay: true,
			path: '/assets/404.animation.json'
		};

		this.animation = bodymovin.loadAnimation(animationParams);
    }

}
